export const categories = [
  { slug: 'dianying', name: '电影', icon: 'ri-movie-2-line', count: 2846, description: '热门电影大片，涵盖动作、喜剧、科幻、爱情等多种类型' },
  { slug: 'dianshiju', name: '电视剧', icon: 'ri-tv-2-line', count: 3520, description: '精选国内外热播电视剧，日更不断，追剧首选' },
  { slug: 'zongyi', name: '综艺', icon: 'ri-emotion-laugh-line', count: 1824, description: '热门综艺节目全收录，搞笑娱乐一网打尽' },
  { slug: 'dongman', name: '动漫', icon: 'ri-ghost-line', count: 4210, description: '日漫国漫全收录，热血冒险治愈日常应有尽有' },
  { slug: 'jilupian', name: '纪录片', icon: 'ri-earth-line', count: 968, description: '自然人文历史科技，打开认知世界的窗口' },
  { slug: 'tiyu', name: '体育', icon: 'ri-basketball-line', count: 756, description: '赛事回放、精彩集锦，体育迷的天堂' },
  { slug: 'yinyue', name: '音乐', icon: 'ri-music-2-line', count: 1532, description: 'MV、演唱会、音乐现场，视听双重享受' },
  { slug: 'youxi', name: '游戏', icon: 'ri-gamepad-line', count: 2105, description: '游戏实况、赛事直播、攻略教程全涵盖' },
];

export const hotVideos = [
  {
    id: 1,
    title: '《流浪地球3》官方预告片首发',
    category: '电影',
    categorySlug: 'dianying',
    duration: '3:25',
    views: 1285000,
    rating: 9.2,
    thumbnail: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20poster%20with%20a%20massive%20planet%20engine%20in%20deep%20space%2C%20dramatic%20orange%20and%20teal%20lighting%2C%20cinematic%20composition%2C%20epic%20scale%2C%20photorealistic%20CGI%20style%2C%20minimal%20background%20with%20stars&width=640&height=360&seq=hot-video-01&orientation=landscape',
    description: '继前两部创下票房纪录后，《流浪地球3》再度回归，太阳急速老化膨胀，人类面临前所未有的生存危机。',
    date: '2026-08-10',
  },
  {
    id: 2,
    title: '《长安十二时辰》续集定档',
    category: '电视剧',
    categorySlug: 'dianshiju',
    duration: '45:20',
    views: 985000,
    rating: 9.5,
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20cityscape%20at%20night%20with%20lanterns%20and%20traditional%20architecture%2C%20warm%20golden%20lighting%2C%20atmospheric%20mist%2C%20historical%20drama%20cinematic%20style%2C%20epic%20composition&width=640&height=360&seq=hot-video-02&orientation=landscape',
    description: '备受期待的《长安十二时辰》续集终于定档，原班人马再度集结，展开全新篇章的悬疑故事。',
    date: '2026-08-09',
  },
  {
    id: 3,
    title: '《歌手2026》总决赛巅峰对决',
    category: '综艺',
    categorySlug: 'zongyi',
    duration: '120:00',
    views: 2100000,
    rating: 9.0,
    thumbnail: 'https://readdy.ai/api/search-image?query=Grand%20music%20stage%20with%20spotlights%20and%20dramatic%20lighting%2C%20singer%20performing%20at%20center%20stage%2C%20concert%20atmosphere%20with%20audience%20silhouettes%2C%20warm%20golden%20and%20red%20tones%2C%20elegant%20composition&width=640&height=360&seq=hot-video-03&orientation=landscape',
    description: '八位顶尖歌手同台竞技，用歌声征服全场观众，本季歌王即将揭晓，精彩不容错过。',
    date: '2026-08-08',
  },
  {
    id: 4,
    title: '《鬼灭之刃》剧场版全球首映',
    category: '动漫',
    categorySlug: 'dongman',
    duration: '98:00',
    views: 3560000,
    rating: 9.8,
    thumbnail: 'https://readdy.ai/api/search-image?query=Anime%20style%20demon%20slayer%20battle%20scene%20with%20water%20breathing%20technique%2C%20dynamic%20action%20pose%2C%20vibrant%20blue%20and%20red%20energy%20effects%2C%20Japanese%20art%20style%2C%20dramatic%20composition%20with%20cherry%20blossoms&width=640&height=360&seq=hot-video-04&orientation=landscape',
    description: '人气动漫《鬼灭之刃》全新剧场版全球同步首映，炭治郎与伙伴们迎来最强大的敌人。',
    date: '2026-08-07',
  },
  {
    id: 5,
    title: '《地球脉动III》深海秘境特辑',
    category: '纪录片',
    categorySlug: 'jilupian',
    duration: '58:30',
    views: 685000,
    rating: 9.7,
    thumbnail: 'https://readdy.ai/api/search-image?query=Deep%20ocean%20documentary%20scene%20with%20bioluminescent%20creatures%20and%20coral%20reef%2C%20majestic%20whale%20silhouette%20in%20deep%20blue%20water%2C%20ethereal%20lighting%2C%20BBC%20nature%20documentary%20style%2C%20cinematic%20underwater&width=640&height=360&seq=hot-video-05&orientation=landscape',
    description: 'BBC金牌制作团队历时五年打造，深入从未被拍摄过的深海秘境，揭示海洋最神秘的生态系统。',
    date: '2026-08-06',
  },
  {
    id: 6,
    title: 'NBA季后赛：湖人vs勇士精彩回放',
    category: '体育',
    categorySlug: 'tiyu',
    duration: '25:40',
    views: 890000,
    rating: 8.9,
    thumbnail: 'https://readdy.ai/api/search-image?query=Professional%20basketball%20game%20action%20shot%20with%20player%20dunking%2C%20dramatic%20arena%20lighting%2C%20crowd%20energy%2C%20NBA%20playoff%20atmosphere%2C%20warm%20golden%20court%20lighting%2C%20dynamic%20sports%20photography&width=640&height=360&seq=hot-video-06&orientation=landscape',
    description: '两大豪门球队季后赛狭路相逢，全场高能不断，最后一秒绝杀引爆全场。',
    date: '2026-08-05',
  },
];

export const latestVideos = [
  {
    id: 7,
    title: '《封神第二部》终极预告曝光',
    category: '电影',
    categorySlug: 'dianying',
    duration: '2:48',
    views: 756000,
    rating: 8.8,
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20mythology%20fantasy%20film%20scene%20with%20ancient%20warriors%20in%20elaborate%20armor%2C%20epic%20battle%20formation%2C%20dramatic%20sky%20with%20golden%20clouds%2C%20cinematic%20lighting%2C%20grand%20scale&width=640&height=360&seq=latest-video-01&orientation=landscape',
    date: '2026-08-11',
  },
  {
    id: 8,
    title: '《狂飙》导演新作《暗涌》开播',
    category: '电视剧',
    categorySlug: 'dianshiju',
    duration: '42:15',
    views: 623000,
    rating: 9.1,
    thumbnail: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20TV%20drama%20scene%20in%20modern%20Chinese%20city%20at%20night%2C%20detective%20in%20trench%20coat%2C%20rainy%20street%20with%20neon%20reflections%2C%20noir%20lighting%2C%20suspenseful%20atmosphere&width=640&height=360&seq=latest-video-02&orientation=landscape',
    date: '2026-08-10',
  },
  {
    id: 9,
    title: '《密室大逃脱》新一季重磅回归',
    category: '综艺',
    categorySlug: 'zongyi',
    duration: '68:30',
    views: 510000,
    rating: 8.5,
    thumbnail: 'https://readdy.ai/api/search-image?query=Mysterious%20escape%20room%20set%20with%20puzzle%20elements%20and%20dramatic%20lighting%2C%20team%20of%20people%20solving%20clues%2C%20immersive%20atmosphere%2C%20warm%20golden%20and%20dim%20ambient%20lighting&width=640&height=360&seq=latest-video-03&orientation=landscape',
    date: '2026-08-09',
  },
  {
    id: 10,
    title: '《进击的巨人》最终季完结篇',
    category: '动漫',
    categorySlug: 'dongman',
    duration: '85:00',
    views: 4200000,
    rating: 9.6,
    thumbnail: 'https://readdy.ai/api/search-image?query=Anime%20colossal%20titan%20dramatic%20scene%20with%20massive%20scale%20destruction%2C%20steam%20and%20smoke%2C%20intense%20orange%20sunset%20sky%2C%20epic%20anime%20cinematography%2C%20dynamic%20composition&width=640&height=360&seq=latest-video-04&orientation=landscape',
    date: '2026-08-08',
  },
  {
    id: 11,
    title: '柴可夫斯基《天鹅湖》全剧高清',
    category: '音乐',
    categorySlug: 'yinyue',
    duration: '135:00',
    views: 320000,
    rating: 9.4,
    thumbnail: 'https://readdy.ai/api/search-image?query=Ballet%20performance%20of%20Swan%20Lake%20on%20grand%20stage%2C%20ballerinas%20in%20white%20tutus%2C%20elegant%20spotlight%20lighting%2C%20classical%20arts%20atmosphere%2C%20refined%20composition%20with%20orchestra%20pit&width=640&height=360&seq=latest-video-05&orientation=landscape',
    date: '2026-08-07',
  },
  {
    id: 12,
    title: '《黑神话：悟空》资料片实机演示',
    category: '游戏',
    categorySlug: 'youxi',
    duration: '18:20',
    views: 1890000,
    rating: 9.3,
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20mythology%20game%20scene%20with%20monkey%20warrior%20in%20ancient%20armor%2C%20lush%20bamboo%20forest%20with%20sunlight%20rays%2C%20photorealistic%20game%20graphics%2C%20dynamic%20combat%20pose%2C%20epic%20atmosphere&width=640&height=360&seq=latest-video-06&orientation=landscape',
    date: '2026-08-06',
  },
];

export const features = [
  {
    icon: 'ri-4k-line',
    title: '超高清画质',
    description: '支持4K超高清播放，细腻画质带来身临其境的观影体验，每一帧都是视觉享受。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速加载',
    description: '全球CDN加速节点覆盖，智能码率自适应技术，确保流畅不卡顿的播放体验。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多终端同步',
    description: '手机、平板、电脑、电视全终端覆盖，观影进度云端同步，随时随地继续观看。',
  },
  {
    icon: 'ri-download-cloud-2-line',
    title: '离线缓存',
    description: '支持视频离线下载，无网络也能畅享精彩内容，旅途中最贴心的娱乐伴侣。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全无广告',
    description: '纯净观影环境，无弹窗广告骚扰，会员专享免广告特权，专注内容本身。',
  },
  {
    icon: 'ri-vip-diamond-line',
    title: '会员专属',
    description: '注册解锁独家内容、超前点播、专属推荐等会员权益，尊享极致娱乐体验。',
  },
];

export const faqs = [
  {
    question: '蜜桃在线是免费的吗？',
    answer: '蜜桃在线提供大量免费高清视频内容，部分精选内容和最新资源为会员专属。注册账号即可免费观看海量视频，升级VIP会员可解锁更多独家资源与专属权益，包括超前点播、4K画质和无广告体验。',
  },
  {
    question: '如何注册蜜桃在线账号？',
    answer: '注册非常简单！点击网站右上角的「注册」按钮，输入手机号或邮箱地址，设置密码后即可完成注册。您也可以使用微信、QQ等第三方账号一键登录，最快10秒就能开始您的观影之旅。',
  },
  {
    question: '蜜桃在线支持哪些设备？',
    answer: '蜜桃在线支持全平台访问，包括Windows/Mac电脑浏览器、iOS/Android手机及平板、智能电视和电视盒子。您可以在应用商店搜索「蜜桃在线」下载官方APP，或直接在浏览器访问官网观看。',
  },
  {
    question: '视频播放卡顿怎么办？',
    answer: '遇到播放卡顿时，可以尝试以下方法：1) 切换视频清晰度，选择较低的码率；2) 检查您的网络连接状况；3) 刷新页面或重启APP；4) 清理浏览器缓存。如果问题持续，请联系客服获取技术支持。',
  },
  {
    question: '如何获取最新资源更新通知？',
    answer: '您可以通过以下方式第一时间获取更新：关注蜜桃在线官方微信公众号和微博账号，开启APP推送通知，或订阅我们的邮件通讯。新资源上线时我们会第一时间通知您。',
  },
  {
    question: '会员可以退款吗？',
    answer: '我们提供7天无理由退款保障。如果您对会员服务不满意，在购买后7天内可联系客服申请全额退款。超过7天的退款申请将根据具体情况评估处理。详情请查看我们的退款政策或联系在线客服。',
  },
];

export const testimonials = [
  {
    name: '张先生',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20photo%2C%20friendly%20smile%2C%20clean%20white%20background%2C%20business%20casual%20attire%2C%20warm%20natural%20lighting%2C%20headshot%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
    rating: 5,
    comment: '用了蜜桃在线快一年了，资源更新速度真的没话说，新电影上线速度比别的平台快多了，画质也很棒！',
  },
  {
    name: '李女士',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20photo%2C%20warm%20smile%2C%20clean%20white%20background%2C%20casual%20elegant%20attire%2C%20soft%20natural%20lighting%2C%20headshot%20style&width=80&height=80&seq=avatar-02&orientation=squarish',
    rating: 5,
    comment: '作为一个追剧达人，蜜桃在线的多终端同步功能太实用了，手机上没看完的回家电视上接着看，体验超棒。',
  },
  {
    name: '王同学',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20male%20student%20portrait%2C%20friendly%20expression%2C%20clean%20white%20background%2C%20casual%20hoodie%2C%20warm%20natural%20lighting%2C%20headshot%20style&width=80&height=80&seq=avatar-03&orientation=squarish',
    rating: 4,
    comment: '动漫资源太全了！作为一个二次元爱好者，这里简直就是天堂，国漫日漫应有尽有，强烈推荐！',
  },
];

export const features_articles = [
  {
    id: 101,
    title: '2026暑期档最值得期待的电影清单',
    excerpt: '暑期档大片云集，从国产科幻巨制到好莱坞动作大片，我们为你盘点了今年夏天不容错过的10部电影。',
    category: '电影',
    categorySlug: 'dianying',
    date: '2026-08-11',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cinema%20movie%20theater%20interior%20with%20red%20seats%20and%20large%20silver%20screen%2C%20warm%20ambient%20lighting%2C%20cinematic%20atmosphere%2C%20elegant%20composition&width=640&height=360&seq=article-101&orientation=landscape',
  },
  {
    id: 102,
    title: '独家揭秘：《长安十二时辰》续集幕后故事',
    excerpt: '导演携主创团队首次透露续集创作历程，从剧本打磨到场景搭建，带你走进这部年度大剧的幕后世界。',
    category: '电视剧',
    categorySlug: 'dianshiju',
    date: '2026-08-09',
    thumbnail: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20production%20set%20with%20director%20and%20crew%2C%20professional%20camera%20equipment%2C%20warm%20set%20lighting%2C%20documentary%20style%20photography&width=640&height=360&seq=article-102&orientation=landscape',
  },
  {
    id: 103,
    title: '纪录片推荐：五部改变世界观的神作',
    excerpt: '精选五部豆瓣高分纪录片，从宇宙探索到人文历史，每一部都将颠覆你对世界的认知。',
    category: '纪录片',
    categorySlug: 'jilupian',
    date: '2026-08-07',
    thumbnail: 'https://readdy.ai/api/search-image?query=Documentary%20filmmaking%20scene%20with%20professional%20camera%20in%20nature%2C%20golden%20hour%20sunlight%2C%20sweeping%20landscape%20vista%2C%20cinematic%20documentary%20style%2C%20warm%20natural%20tones&width=640&height=360&seq=article-103&orientation=landscape',
  },
];